export default __webpack_public_path__ + "static/media/zenhub.d6d466aa.svg";